import styled from "styled-components";

export const ContainerAtencionSinTunroSelect = styled.div`
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 40px;
  .title {
    display: flex;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    text-align: center;
    width: 314px;
  }
`;
